(() => {
  if (window.__ssbProfileTabsBoot) return;
  window.__ssbProfileTabsBoot = true;

  const ROOT_SELECTOR = '[data-profile-shell]';

  /** Tab from URL. Use profile_tab= — ?view= is reserved by Shopify for alternate JSON templates. */
  function getProfileTabFromSearch() {
    try {
      const params = new URLSearchParams(window.location.search);
      let raw = params.get('profile_tab');
      if (!raw) raw = params.get('view');
      const v = raw ? String(raw).trim().toLowerCase() : '';
      if (v === 'account' || v === 'orders' || v === 'address') return v;
    } catch {
      /* ignore */
    }
    return null;
  }

  /** Apply profile_tab= (or default account) to every profile shell — safe to call multiple times. */
  function syncProfileShellsFromUrl() {
    const v = getProfileTabFromSearch() || 'account';
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      const tabs = root.querySelectorAll('[data-profile-tab]');
      const panels = root.querySelectorAll('[data-profile-panel]');
      if (!tabs.length || !panels.length) return;
      tabs.forEach((btn) => {
        const on = btn.getAttribute('data-profile-tab') === v;
        btn.classList.toggle('profile-sidebar__item--active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-profile-panel') !== v;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  window.addEventListener('pageshow', () => {
    syncProfileShellsFromUrl();
  });

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.tabsBound === '1') return;
      if (!bindRoot(root)) return;
      root.dataset.tabsBound = '1';
    });
    syncProfileShellsFromUrl();
    queueMicrotask(syncProfileShellsFromUrl);
    setTimeout(syncProfileShellsFromUrl, 0);
  }

  function bindRoot(root) {
    const tabButtons = Array.from(root.querySelectorAll('[data-profile-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-profile-panel]'));
    if (!tabButtons.length || !panels.length) return false;

    const fromUrl = getProfileTabFromSearch();
    if (fromUrl) activateTab(root, fromUrl);

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.profileTab;
        if (tab) activateTab(root, tab);
      });
    });
    return true;
  }

  function activateTab(root, tab) {
    const tabButtons = Array.from(root.querySelectorAll('[data-profile-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-profile-panel]'));

    tabButtons.forEach((btn) => {
      const active = btn.dataset.profileTab === tab;
      btn.classList.toggle('profile-sidebar__item--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.profilePanel !== tab;
    });

    try {
      const url = new URL(window.location.href);
      if (tab === 'account' || tab === 'orders' || tab === 'address') {
        url.searchParams.delete('view');
        url.searchParams.set('profile_tab', tab);
        window.history.replaceState(null, '', url.toString());
      }
    } catch {
      /* ignore */
    }
  }
})();
